import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserActivity = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 14H6.5L9 3L12 21L15.5 10L17 14H21",
		stroke: "#324051",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgUserActivity;
